module.exports = __webpack_public_path__ + "static/media/sin_guardados.5409c542.svg";